import * as React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import { SEO } from "../components/seo";
import { Rating } from "../components/rating";
import { SimilarBooks } from "../components/similar-books";
import { CoverImage } from "../components/cover-image";
import { ShareButtons } from "../components/share-buttons";

const BookTemplate = ({ data }) => {
  const book = data.mongodbGetsimilarbooksBooks;
  const title = getTitle(book);
  const description = getDescription(book);
  const canonicalUrl = getCanonicalUrl(
    data.site.siteMetadata.siteUrl,
    book
  );
 
  return (
    <Layout>
      <section className="text-gray-600 body-font overflow-hidden">
        <div className="container px-5 py-4 mx-auto">
          <h1 className="text-gray-900 text-3xl title-font font-medium mb-1 text-left">
            Discover books similar to "{book.name}"
          </h1>
          <div className="py-5 lg:w-5/5 mx-auto flex flex-wrap">
            <CoverImage
              cover_file_name={book.cover_file_name}
              className="lg:w-1/3 w-full object-scale-down object-top"
              width={480}
              height={690}
              alt={`${book.name} cover`}
            />
            <div className="lg:w-2/3 w-full lg:pl-10 mt-6 lg:mt-0">
              <h3 className="text-sm title-font text-gray-500 tracking-widest">
                {book.authors.join(", ")}
              </h3>
              <h2 className="text-gray-900 text-3xl title-font font-medium mb-1">
                {book.name}
              </h2>
              <Rating rating={book.rating} />
              {book.series && (
                <p className="mb-3 title-font text-gray-500 tracking-widest">
                  Part of{" "}
                  <a
                    className="underline text-custom-link"
                    href={`/series/${book.series.id}/${book.series.slug}/`}
                  >
                    "{book.series.name}" series
                  </a>
                </p>
              )}
              <ShareButtons
                url={canonicalUrl}
                title={title}
                description={description}
              />
              <p className="leading-relaxed">{book.annotation}</p>
            </div>
          </div>

          <div className="mx-auto mt-12">
            <h3 className="text-gray-900 text-3xl title-font font-medium mb-1 text-center">
              List of books similar to "{book.name}":
            </h3>
            <SimilarBooks similarBooks={book.similar_books} />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const pageQuery = graphql`
  query ($id: Int!) {
    mongodbGetsimilarbooksBooks(book_id: { eq: $id }) {
      book_id
      name
      rating
      slug
      cover_file_name
      authors
      annotation
      series {
        id
        name
        name_lowercase
        slug
      }
      similar_books {
        annotation
        authors
        cover_file_name
        id
        name
        name_lowercase
        slug
      }
    },
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;

export default BookTemplate;

export const Head = ({ location, data }) => {
  const book = data.mongodbGetsimilarbooksBooks;
  const title = getTitle(book);
  const description = getDescription(book);
  const imageUrl = book.cover_file_name ? `${data.site.siteMetadata.siteUrl}/images/${book.cover_file_name}` : null;
  return (
    <>
      <SEO title={title} description={description} pathname={location.pathname} imageUrl={imageUrl}  />
    </>
  );
};

function getTitle(book) {
  return `Books similar to "${book.name}" by ${book.authors.join(", ")}`;
}

function getDescription(book) {
  return `Looking for books similar to "${book.name}"? Explore our curated list of similar reads to enjoy new stories and authors. Discover your next favorite book on GetSimilarBooks.`;
}

function getCanonicalUrl(siteUrl, book) {
  return `${siteUrl}/book/${book.book_id}/${book.slug}/`;
}